import { defineStore } from 'pinia'

export const useMqttClientTesterStore = defineStore('mqttTester', {
  actions: {
    addToHistory(message) {
      this.history.unshift(message)
    },

    clearHistory() {
      this.history = []
    },

    setPayload(newPayload) {
      this.payload = newPayload
    },

    setQos(newQos) {
      this.qos = newQos
    },

    setRetain(newRetain) {
      this.retain = newRetain
    },

    setTopic(newTopic) {
      this.topic = newTopic
    },
  },

  state: () => ({
    history: [], // Publish history
    payload: '', // Current payload
    qos: 0, // QoS level
    retain: false, // Retain flag
    topic: '', // Current topic
  }),
})
